var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-divider-line-text"},[_c('div',{staticClass:"e-divider-line-text__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }